import * as React from 'react'

import LocationIcon from '~/client/src/shared/components/LocationIcon/LocationIcon'
import {
  ResourceTypeId,
  RESOURCE_ROOT_FIELDS,
} from '~/client/src/shared/constants/resourceTypes'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'

import { IResourceRecord } from '../definitions/types'

interface IIconRecord {
  color?: string | null
  iconName?: IResourceRecord['iconName']
}

/**
 * A row's own glyph, where the record carries one. A type qualifies when its form actually
 * edits `iconName` - read off RESOURCE_ROOT_FIELDS rather than named here, so adding a type
 * to that table is all it takes. Equipment and Locations qualify today (STX1-597); every
 * other type keeps the per-type semantic icon its caller passes as the fallback.
 *
 * Reads the same ICON_DATA table the map markers and the table's Icon column read, so one
 * record cannot show two glyphs.
 */
export function renderResourceRecordIcon(
  resourceTypeId: string,
  record: IIconRecord | null | undefined,
  fallbackIcon: React.ReactNode,
  className?: string,
): React.ReactNode {
  const editsOwnIcon = (RESOURCE_ROOT_FIELDS[resourceTypeId] || []).includes(
    'iconName',
  )
  if (!editsOwnIcon || !(record?.color || record?.iconName)) {
    return fallbackIcon
  }

  // Equipment keeps its wrench when only a colour was set; a location has no single
  // default glyph - its kind decides - so a location with no iconName keeps the fallback.
  const iconName =
    record.iconName ||
    (resourceTypeId === ResourceTypeId.OFFLOADING_EQUIPMENT
      ? MapViewLocationIcon.Equipment
      : null)
  if (!iconName) return fallbackIcon

  return (
    <LocationIcon
      iconName={iconName}
      color={record.color || undefined}
      className={className}
    />
  )
}
